export default class ArrayX extends Array {
  /**
   *
   * @param {[any]} value
   * @example [1, 2, 3] || [{example1: "example"}, {example2: "example"}]
   */
  super() {}
}

ArrayX.prototype.distinct = function () {
  return this.filter((item, index) =>
    this.getDistinctArrayValues(item, index, this),
  );
};

ArrayX.prototype.getDistinctArrayValues = function (item, index, array) {
  return array.indexOf(item) === index;
};

ArrayX.prototype.toDistinct = function () {
  return this.filter((obj, index) =>
    this.getDistinctArrayObjects(obj, index, this),
  );
};

ArrayX.prototype.getDistinctArrayObjects = function (obj, index, array) {
  return (
    array.findIndex((item) => JSON.stringify(item) === JSON.stringify(obj)) ===
    index
  );
};

ArrayX.prototype.toDistinctProperty = function (key) {
  return this.filter((obj, index) =>
    this.getDistinctArrayProperties(obj, key, index, this),
  );
};

ArrayX.prototype.getDistinctArrayProperties = function (
  obj,
  key,
  index,
  array,
) {
  return array.findIndex((item) => item[key] === obj[key]) === index;
};

ArrayX.prototype.toGroup = function (predicate) {
  return Object.groupBy(this, predicate);
};
